import { Laptop, Moon, Sun } from "lucide-react"
import { Button } from "@/components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { useTheme, type ThemePreference } from "@/lib/theme"

const choices: { value: ThemePreference; label: string; icon: typeof Sun }[] = [
  { value: "light", label: "Light", icon: Sun },
  { value: "dark", label: "Dark", icon: Moon },
  { value: "system", label: "System", icon: Laptop },
]

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  const CurrentIcon = choices.find((choice) => choice.value === theme)?.icon || Laptop

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild><Button variant="ghost" size="icon" aria-label="Change color theme"><CurrentIcon className="size-4" /></Button></DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {choices.map(({ value, label, icon: Icon }) => <DropdownMenuItem key={value} onSelect={() => setTheme(value)}><Icon className="size-4" />{label}{theme === value && <span className="ml-auto text-xs text-muted-foreground">Current</span>}</DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
